import React from 'react'
import {ErrorMessage, FormikErrors} from 'formik'
import Select from 'react-select'

interface Props {
  containerClassName?: string
  label?: string
  name: string
  type?: string
  placeholder?: string
  onChange: (e: React.ChangeEvent<any>) => void
  className?: string
  errors: FormikErrors<any>
  touched: any
  labelClassName?: string
  required?: boolean
  disabled?: boolean
  multiple?: boolean
  options: {label: string; value: string}[] | undefined
  values?: any
  style?: any
  setFieldValue: any
  arrValue?: string
  defaultValue?: any
  isClearable?: any
  id?: string
}

const FormSelect = React.memo((props: Props) => {
  const {
    containerClassName,
    label,
    name,
    type,
    className,
    errors,
    touched,
    labelClassName,
    required,
    options,
    placeholder,
    disabled,
    values,
    setFieldValue,
    multiple,
    arrValue,
    style,
    defaultValue,
    isClearable,
    id,
    ...rest
  } = props

  const fieldId = id ?? name
  const labelId = `${fieldId}-label`
  const errorId = `${fieldId}-error`

  const selectStyles = {
    menuList: (styles: any) => ({
      ...styles,
      maxHeight: 155,
    }),
    menuPortal: (styles: any) => ({
      ...styles,
      zIndex: 100001,
    }),
  }

  return (
    <div className={label ? 'row mb-6' : 'col-lg-6 '}>
      {label && (
        <label id={labelId} htmlFor={fieldId} className={`mb-1 fw-bolder fs-6 ${labelClassName || 'col-lg-4'}`}>
          <span className={required ? 'required' : ''}>{label}</span>
        </label>
      )}
      <div className={containerClassName ?? 'col-lg-6 '} data-cy={`${name}-checkbox-field`}>
        {multiple ? (
          <Select
            {...rest}
            inputId={fieldId}
            aria-labelledby={label ? labelId : undefined}
            aria-required={required}
            aria-invalid={!!(errors[name] && touched[name])}
            aria-describedby={errors[name] && touched[name] ? errorId : undefined}
            className='customSelect'
            menuPlacement='bottom'
            menuPortalTarget={document.body}
            menuPosition='fixed'
            styles={selectStyles}
            name={name}
            options={options}
            onChange={(option) => {
              let selectIds = option.map((item) => item?.value)
              setFieldValue(name, selectIds)
            }}
            value={options?.filter((obj) => values?.[name]?.includes(obj?.value))}
            isMulti={multiple}
            isDisabled={disabled}
            defaultValue={defaultValue}
            data-cy={`${name}-checkbox-field`}
          />
        ) : (
          <Select
            {...rest}
            inputId={fieldId}
            aria-labelledby={label ? labelId : undefined}
            aria-required={required}
            aria-invalid={!!(errors[name] && touched[name])}
            aria-describedby={errors[name] && touched[name] ? errorId : undefined}
            className='customSelect'
            menuPlacement='bottom'
            menuPortalTarget={document.body}
            menuPosition='fixed'
            styles={selectStyles}
            name={name}
            isClearable={isClearable}
            options={options}
            isDisabled={disabled}
            onChange={(option) => {
              if (option?.isReset) {
                setFieldValue(option?.resetValue, '')
              }
              setFieldValue(name, option?.value)
            }}
            value={
              arrValue || values?.[name]
                ? options?.find((obj) => obj?.value === (arrValue ? arrValue : values?.[name]))
                : null
            }
            defaultValue={defaultValue}
            data-cy={`${name}-checkbox-field`}
          />
        )}
        <div id={errorId} className='fv-plugins-message-container text-danger fw-bolder small text-end mt-1'>
          <ErrorMessage name={name} component='div' className='field-error-message' />
        </div>
      </div>
    </div>
  )
})

export default FormSelect
